import { render, staticRenderFns } from "./GaleriaImagenes.vue?vue&type=template&id=bbe6159e&scoped=true&"
import script from "./GaleriaImagenes.vue?vue&type=script&lang=ts&"
export * from "./GaleriaImagenes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe6159e",
  null
  
)

export default component.exports